'use strict';

/**
 * Sets timeout to close of flash messages based on their CSS class
 * Has mediaQuery event to display flash messages within content or not
 *
 * @type {{manageAlerts: waFlashMessages.manageAlerts}}
 * @see https://developer.mozilla.org/de/docs/Web/API/Window/matchMedia
 */
var waFlashMessages = {
	manageAlerts: function() {
		let mediaQueryEvent = function() {
			if (waMediaQueries.queryXs.matches) {
				$('.alert-message').removeClass('alert-fixed');
				$('.alert-message').removeClass('alert-fixed-top-right');
			}
		};

		mediaQueryEvent();
		waMediaQueries.queryXs.addListener(mediaQueryEvent);

		$('.alert').alert();

		if ($('.alert').hasClass('alert-danger') === false) {
			window.setTimeout(function() {
				$('.alert').alert('close');
			}, 5000);
		} else {
			window.setTimeout(function() {
				$('.alert').alert('close');
			}, 15000);
		}

		$('body').on('close.bs.alert', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$(e.target).slideUp('200');
			$('.alert-message').hide();
		});
	}
};
